import { render, staticRenderFns } from "./TabelaCadastrosVuetify.vue?vue&type=template&id=499216cd"
import script from "./TabelaCadastrosVuetify.vue?vue&type=script&lang=js"
export * from "./TabelaCadastrosVuetify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports